<template>
<div class="chapter">
<div class="inner_page">
<div class="plm_hd">Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/JA_genpref">General preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/JA_autpref">Author’s preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/JA_abbrev">Chief abbreviations</a>
<div class="sgc-toc-level-2">
<a href="#/Text/JA_abbrev#sigil_toc_id_1">Bible versions</a>
</div>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/JA_bibliog">Select bibliography</a>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/JA_J_intro"><span class="bold">JOEL</span></a>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/JA_J_intro#sigil_toc_id_2"><span class="bold">Introduction</span></a>
<div class="sgc-toc-level-2">
<a href="#/Text/JA_J_intro#sigil_toc_id_3">1. Structural patterns in the book of Joel</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/JA_J_intro#sigil_toc_id_4">2. The date of the book</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/JA_J_intro#sigil_toc_id_5">3. Joel and the ‘Book of the Twelve’</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/JA_J_intro#sigil_toc_id_6">4. Joel and intertextuality</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/JA_J_intro#sigil_toc_id_7">5. The setting and genre of the book</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/JA_J_intro#sigil_toc_id_8">6. The message of Joel</a>
</div>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/JA_J_anal" title="Link target outside of Sample"><span class="bold">Analysis</span></span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/JA_J_ch01" title="Link target outside of Sample"><span class="bold">Commentary</span></span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/JA_J_ch01#sigil_toc_id_9" title="Link target outside of Sample">1. Introduction (1:1)</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/JA_J_ch02" title="Link target outside of Sample">2. God’s grace during past crises (1:2 – 2:27)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_J_ch02#sigil_toc_id_10" title="Link target outside of Sample">A. The first call to lament (1:2–20)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_J_ch02#sigil_toc_id_11" title="Link target outside of Sample">B. The second call to lament (2:1–17)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_J_ch02#sigil_toc_id_12" title="Link target outside of Sample">C. The Lord’s response (2:18–27)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/JA_J_ch03" title="Link target outside of Sample">3. God’s grace in the crisis to come (2:28 – 3:21 [<span class="smallcaps">mt</span> 3:1 – 4:21])</span>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_J_ch03#sigil_toc_id_13" title="Link target outside of Sample">A. The outpouring of the spirit (2:28–32 [<span class="smallcaps">mt</span> 3:1–5])</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_J_ch03#sigil_toc_id_14" title="Link target outside of Sample">B. The crimes and judgment of the nations (3:1–8 [<span class="smallcaps">mt</span> 4:1–8])</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_J_ch03#sigil_toc_id_15" title="Link target outside of Sample">C. The last battle (3:9–21 [<span class="smallcaps">mt</span> 4:9–21])</span>
</div>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/JA_amos_intro" title="Link target outside of Sample"><span class="bold">AMOS</span></span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/JA_amos_intro#sigil_toc_id_16" title="Link target outside of Sample"><span class="bold">Introduction</span></span>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_amos_intro#sigil_toc_id_17" title="Link target outside of Sample">1. The book of Amos as a work of literature</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_amos_intro#sigil_toc_id_18" title="Link target outside of Sample">2. Amos the prophet</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_amos_intro#sigil_toc_id_19" title="Link target outside of Sample">3. The political and social context of Amos’s preaching</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_amos_intro#sigil_toc_id_20" title="Link target outside of Sample">4. Interpreting the book of Amos</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_amos_intro#sigil_toc_id_21" title="Link target outside of Sample">5. Theology and ethics in Amos</span>
</div>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/JA_A_anal" title="Link target outside of Sample"><span class="bold">Analysis</span></span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/JA_A_ch01" title="Link target outside of Sample"><span class="bold">Commentary</span></span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/JA_A_ch01#sigil_toc_id_22" title="Link target outside of Sample">1. Introduction (1:1–2)</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/JA_A_ch02" title="Link target outside of Sample">2. Israel has become like the nations (1:3 – 2:16)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_A_ch02#sigil_toc_id_23" title="Link target outside of Sample">A. Oracles against foreign nations (1:3 – 2:3)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_A_ch02#sigil_toc_id_24" title="Link target outside of Sample">B. Oracles against Israel and Judah (2:4–16)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/JA_A_ch03" title="Link target outside of Sample">3. A divine word against the people of Israel (3:1 – 4:13)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_A_ch03#sigil_toc_id_25" title="Link target outside of Sample">A. The lion has roared: fear for your lives (3:1–8)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_A_ch03#sigil_toc_id_26" title="Link target outside of Sample">B. Israel’s transgressions on Mount Samaria and at the Bethel altar (3:9 – 4:3)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_A_ch03#sigil_toc_id_27" title="Link target outside of Sample">C. Israel’s transgressions in Bethel: lack of repentance (4:4–13)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/JA_A_ch04" title="Link target outside of Sample">4. A prophetic word against the house of Israel (5:1 – 6:14)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_A_ch04#sigil_toc_id_28" title="Link target outside of Sample">A. Injustice, seeking the Lord, death (5:1–17)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_A_ch04#sigil_toc_id_29" title="Link target outside of Sample">B. The Day of the Lord and Israel’s corrupt worship (5:18–27)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_A_ch04#sigil_toc_id_30" title="Link target outside of Sample">C. Israel’s current prosperity and future failures (6:1–14)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/JA_A_ch05" title="Link target outside of Sample">5. The inevitable destruction of IsraeL (7:1 – 9:6)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_A_ch05#sigil_toc_id_31" title="Link target outside of Sample">A. The first two visions: the Lord relents (7:1–6)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_A_ch05#sigil_toc_id_32" title="Link target outside of Sample">B. The third vision: the plumb line (7:7–17)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_A_ch05#sigil_toc_id_33" title="Link target outside of Sample">C. The fourth vision: the end has come (8:1–14)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/JA_A_ch05#sigil_toc_id_34" title="Link target outside of Sample">D. The fifth vision: the destroyed temple (9:1–6)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/JA_A_ch06" title="Link target outside of Sample">6. The raising of the fallen Booth of David (9:7–15)</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/JA_notes" title="Link target outside of Sample">Notes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/praise" title="Link target outside of Sample">Praise for the Tyndale Commentaries</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/author" title="Link target outside of Sample">About the Author</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/moreIVP" title="Link target outside of Sample">Tyndale Commentaries from InterVarsity Press</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/JA_imprint" title="Link target outside of Sample">Copyright</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// JA_contents.vue?34e5bb04